<template>
  <v-app>
    <component
      :is="`${layout}Layout`"
      v-if="(`${layout}Layout` in $options.components)"
    >
      <template v-if="hasAccess">
        <router-view />
      </template>
      <template v-else>
        <Login />
      </template>
    </component>
  </v-app>
</template>

<script>
import DefaultLayout from './layouts/DefaultLayout.vue';
import BackendLayout from './layouts/BackendLayout.vue';
import FullViewLayout from './layouts/FullViewLayout.vue';
import Login from './components/Login.vue';
import apiUtil from './utils/ApiUtil';

export default {
  name: 'App',
  components: {
    Login,
    DefaultLayout,
    BackendLayout,
    FullViewLayout,
  },
  data: () => {
    return {
    };
  },
  computed: {
    hasAccess() {
      return this.$store.state.hasAccess;
    },
    token() {
      return this.$store.state.user.token;
    },
    layout() {
      return this.$route.meta.layout;
    },
  },
  watch: {
    route: {
      handler() {
        if (!this.hasAccess && this.$router.currentRoute.path !== '/login') {
          this.$router.push('/login');
        }
      },
      immediate: true,
    },
    token: {
      handler(token) {
        apiUtil.setToken(token);
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.v-card--disabled > *:not(.v-card__progress) {
  opacity: 0.4 !important;
}
</style>
